import React from 'react';
import { Table, Card } from 'antd';

const columns = [
  {
    title: 'จังหวัด',
    dataIndex: 'province',
    key: 'province',
    fixed: 'left',
  },
  {
    title: 'รวมทั้งหมด',
    dataIndex: 'totalAll',
    key: 'totalAll',
    fixed: 'right',
  },
  {
    title: 'วัด',
    dataIndex: 'temples',
    key: 'temples',
    fixed: 'right',
  },
  {
    title: 'พระอารามหลวง',
    dataIndex: 'royal',
    key: 'royal',
    fixed: 'right',
  },
  {
    title: 'วัดราษฎร์',
    dataIndex: 'raj',
    key: 'raj',
    fixed: 'right',
  },
  {
    title: 'วิสุงคามสีมา',
    dataIndex: 'wisung',
    key: 'wisung',
    fixed: 'right',
  },
  {
    title: 'พัทธสีมา',
    dataIndex: 'pattasima',
    key: 'pattasima',
    fixed: 'right',
  },
  {
    title: 'ที่พักสงฆ์',
    dataIndex: 'monastery',
    key: 'monastery',
    fixed: 'right',
  },

];

const TempleStatsByProvince = ({ data }) => {


  //เรียงจังหวัดใหม่
  const customOrder = [
    // ภาค 4
    "นครสวรรค์",
    "เพชรบูรณ์",
    "กำแพงเพชร",
    "พิจิตร",

    // ภาค 5
    "พิษณุโลก",
    "อุตรดิตถ์",
    "สุโขทัย",
    "ตาก"
  ];


  // ทำการเรียงลำดับจาก customOrder
  const sortedProvince = data.sort((a, b) => {
    return customOrder.indexOf(a.province) - customOrder.indexOf(b.province);
  });

  console.log(sortedProvince);

  // คำนวณยอดรวมของแต่ละคอลัมน์
  const totals = sortedProvince.reduce(
    (acc, item) => {
      acc.totalAll += item.totalAll || 0;
      acc.temples += item.temples || 0;
      acc.royal += item.royal || 0;
      acc.monastery += item.monastery || 0;
      acc.pattasima += item.pattasima || 0;
      acc.wisung += item.wisung || 0;
      acc.raj += item.raj || 0;
      return acc;
    },
    {
      totalAll: 0,
      temples: 0,
      royal: 0,
      monastery: 0,
      pattasima: 0,
      wisung: 0,
      raj: 0,
    }
  );

  return (
    <Card title="สถิติประเภทวัดแยกตามจังหวัด">
      <Table
        columns={columns}
        dataSource={sortedProvince}
        rowKey="province"
        bordered
        pagination={false}
        scroll={{ x: 'max-content' }}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0}><strong>รวม</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={1}><strong>{totals.totalAll}</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={2}><strong>{totals.temples}</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={3}><strong>{totals.royal}</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={4}><strong>{totals.monastery}</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={5}><strong>{totals.pattasima}</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={6}><strong>{totals.wisung}</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={7}><strong>{totals.raj}</strong></Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </Card>
  );
};

export default TempleStatsByProvince;
